import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { RootState } from 'store';
import { appContextSelector } from 'modules/app/appSlice';

interface Props extends RouteProps {
  fallback: string;
  allowedProfileTypes: ProfileType[];
  allowedContextTypes?: PortalContext[];
}

const ProfileRoute: FC<Props> = ({ children, fallback = '/', allowedProfileTypes, allowedContextTypes, ...props }) => {
  const { currentProfile } = useSelector((state: RootState) => state.user);
  const context = useSelector(appContextSelector);

  const matchesContext = allowedContextTypes?.includes(context) ?? true;

  return (
    <Route
      {...props}
      render={(): ReactElement => {
        if (!currentProfile || !allowedProfileTypes.includes(currentProfile.type) || !matchesContext) {
          return <Redirect to={fallback} />;
        }

        return children as ReactElement;
      }}
    />
  );
};

export default ProfileRoute;
